<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{$t('modificationOrdreTravailAffichage.popUpAjoutFace.title')}}
           </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
      <p>{{$t('modificationOrdreTravailAffichage.popUpAjoutFace.description')}}</p>
      <v-client-table v-model="annonceurs" :columns="columns" :options="options" class="mgt-20px"
        ref="tab_annonceurs">
          <div slot="selected" slot-scope="props" class="is-pulled-right">
            <qd-radio v-model="selected"
                      size="is-small"
                      :native-value="props.row.indexRegroupement">
            </qd-radio>
          </div>
          <div slot="annonceur" slot-scope="props">
            <span v-if="props.row.indexRegroupement !== indexRegroupementManuel">
                {{props.row.annonceurs}}
            </span>
            <span v-else>
              {{$t('modificationOrdreTravailAffichage.popUpAjoutFace.autre')}}
            </span>
          </div>
          <div slot="theme" slot-scope="props">
            <span v-if="props.row.indexRegroupement !== indexRegroupementManuel">
                {{props.row.theme}}
            </span>
            <span v-else>
              <b-input v-model="themeAutre"/>
            </span>
          </div>
      </v-client-table>
      <b-field class="mgt-20px">
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close()">
            {{ $t('general.button.cancel')}}
          </a>
        </div>
        <div class="is-pulled-left boutonAction">
          <a class="button is-addOrEdit" @click="ajouterFace">
            {{ $t('modificationOrdreTravailAffichage.popUpAjoutFace.selection') }}
          </a>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { LIST_ICON_AND_COLOR, INDEX_REGROUPEMENT_MANUEL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import * as types from '@/store/modules/logistique/ordreTravailAffichage-mutation-type';

const Ot = createNamespacedHelpers('ordreTravailAff');

export default {
  name: 'popUpAnnonceurOT',
  data() {
    return {
      selected: null,
      themeAutre: null,
      listIconAndColor: LIST_ICON_AND_COLOR,
      indexRegroupementManuel: INDEX_REGROUPEMENT_MANUEL,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
    };
  },
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    columns() {
      return [
        'selected',
        'annonceur',
        'theme',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          selected: '',
          annonceur: this.$i18n.t('modificationOrdreTravailAffichage.popUpAjoutFace.annonceur'),
          theme: this.$i18n.t('modificationOrdreTravailAffichage.popUpAjoutFace.theme'),
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          annonceur: 'has-text-link has-text-weight-bold ellipsis',
          selected: 'colonneSelected',
        },
        cellClasses: {
          annonceur: [
            {
              class: 'has-background-manuel ',
              condition: row => row.indexRegroupement === INDEX_REGROUPEMENT_MANUEL,
            },
            {
              class: this.getClass(1),
              condition: row => row.indexRegroupement === 1,
            },
            {
              class: this.getClass(2),
              condition: row => row.indexRegroupement === 2,
            },
            {
              class: this.getClass(3),
              condition: row => row.indexRegroupement === 3,
            },
            {
              class: this.getClass(4),
              condition: row => row.indexRegroupement === 4,
            },
            {
              class: this.getClass(5),
              condition: row => row.indexRegroupement === 5,
            },
            {
              class: this.getClass(6),
              condition: row => row.indexRegroupement === 6,
            },
            {
              class: this.getClass(7),
              condition: row => row.indexRegroupement === 7,
            },
            {
              class: this.getClass(8),
              condition: row => row.indexRegroupement === 8,
            },
            {
              class: this.getClass(9),
              condition: row => row.indexRegroupement === 9,
            },
            {
              class: this.getClass(10),
              condition: row => row.indexRegroupement === 10,
            },
            {
              class: this.getClass(11),
              condition: row => row.indexRegroupement === 11,
            },
            {
              class: this.getClass(12),
              condition: row => row.indexRegroupement === 12,
            },
            {
              class: this.getClass(13),
              condition: row => row.indexRegroupement === 13,
            },
            {
              class: this.getClass(14),
              condition: row => row.indexRegroupement === 14,
            },
            {
              class: this.getClass(15),
              condition: row => row.indexRegroupement === 15,
            },
            {
              class: this.getClass(16),
              condition: row => row.indexRegroupement === 16,
            },
            {
              class: this.getClass(17),
              condition: row => row.indexRegroupement === 17,
            },
            {
              class: this.getClass(18),
              condition: row => row.indexRegroupement === 18,
            },
            {
              class: this.getClass(19),
              condition: row => row.indexRegroupement === 19,
            },
            {
              class: this.getClass(20),
              condition: row => row.indexRegroupement === 20,
            },
            {
              class: this.getClass(21),
              condition: row => row.indexRegroupement === 21,
            },
            {
              class: this.getClass(22),
              condition: row => row.indexRegroupement === 22,
            },
            {
              class: this.getClass(23),
              condition: row => row.indexRegroupement === 23,
            },
            {
              class: this.getClass(24),
              condition: row => row.indexRegroupement === 24,
            },
          ],
          theme: [
            {
              class: 'pd-0',
              condition: row => row.indexRegroupement === INDEX_REGROUPEMENT_MANUEL,
            },
          ],
        },
      };
    },
    annonceurs() {
      const ann = cloneDeep(this.ordreTravail.annonceurs);
      ann.push({
        indexRegroupement: INDEX_REGROUPEMENT_MANUEL,
        theme: null,
      });
      return ann;
    },
  },
  methods: {
    ...Ot.mapMutations({
      setOtCourant: types.SET_OT_COURANT,
      setOtAnnonceur: types.SET_OT_ANNONCEUR,
    }),
    ajouterFace() {
      this.error = false;
      this.messages = [];
      if (!this.selected) {
        this.error = true;
        this.messages.push({ message: 'modificationOrdreTravailAffichage.popUpAjoutFace.actionErrors.noSelected' });
        return;
      }
      if (this.selected === INDEX_REGROUPEMENT_MANUEL && (this.themeAutre === '' || this.themeAutre === null)) {
        this.error = true;
        this.messages.push({ message: 'modificationOrdreTravailAffichage.popUpAjoutFace.actionErrors.noTheme' });
        return;
      }
      // gestion erreur
      this.setOtCourant(this.ordreTravail);
      const annonceur = this.annonceurs.find(a => {
        return a.indexRegroupement === this.selected;
      });
      if (this.selected === INDEX_REGROUPEMENT_MANUEL) {
        annonceur.theme = this.themeAutre;
      }
      this.setOtAnnonceur(annonceur);
      this.$router.push({ name: 'l.logistique.ordre_travail-affichage-ajouter-face' });
    },
    getClass(indexRegroupement) {
      if (indexRegroupement === INDEX_REGROUPEMENT_MANUEL) return 'has-background-manuel';
      return this.listIconAndColor[(indexRegroupement - 1) % 24].class;
    },
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>
